var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "_017-logout",
    width: 22.052,
    height: 22.052,
    viewBox: "0 0 22.052 22.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#1f3f93}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M13.782 11.948a.919.919 0 0 0-.919.919v3.675a.92.92 0 0 1-.919.919H9.188V3.679a1.852 1.852 0 0 0-1.251-1.747l-.272-.091h4.28a.92.92 0 0 1 .919.919v2.757a.919.919 0 0 0 1.838 0V2.76A2.76 2.76 0 0 0 11.945 0H2.067a.722.722 0 0 0-.1.02C1.925.02 1.883 0 1.838 0A1.839 1.839 0 0 0 0 1.841V18.38a1.852 1.852 0 0 0 1.251 1.747l5.53 1.843a1.9 1.9 0 0 0 .57.085 1.839 1.839 0 0 0 1.838-1.838V19.3h2.756a2.76 2.76 0 0 0 2.755-2.757v-3.676a.919.919 0 0 0-.919-.919zm0 0",
    className: "cls-1",
    transform: "translate(0 -.004)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M287.17 110.61l-3.675-3.675a.918.918 0 0 0-1.568.65v2.756h-3.675a.919.919 0 1 0 0 1.838h3.675v2.756a.919.919 0 0 0 1.568.65l3.675-3.675a.918.918 0 0 0 0-1.3zm0 0",
    className: "cls-1",
    transform: "translate(-265.387 -102.072)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.6db74accd5341cdbc514108213bbc9ac.svg";
export { ForwardRef as ReactComponent };